export default "skymp5-front/a017f7fc56b46337abc0a65463f5e2b5.png";